import { z } from "zod";

export const qualityInspectionSchema = z.object({
  production_batch_id: z.string().uuid("Selecciona un lote válido"),
  inspection_type: z.enum(["incoming", "in_process", "final", "random"], {
    required_error: "Selecciona el tipo de inspección",
  }),
  visual_check_passed: z.boolean().optional(),
  dimensional_check_passed: z.boolean().optional(),
  functional_check_passed: z.boolean().optional(),
  sample_size: z.number().int().positive("El tamaño de muestra debe ser positivo").optional(),
  overall_rating: z.number().int().min(1, "La calificación mínima es 1").max(5, "La calificación máxima es 5").optional(),
  notes: z.string().optional(),
});

export const qualityDefectSchema = z.object({
  defect_type: z.enum(["visual", "dimensional", "structural", "functional", "cosmetic", "other"], {
    required_error: "Selecciona el tipo de defecto",
  }),
  severity: z.enum(["critical", "major", "minor"], {
    required_error: "Selecciona la severidad",
  }),
  description: z.string().min(10, "La descripción debe tener al menos 10 caracteres"),
  location: z.string().optional(),
  quantity: z.number().int().positive("La cantidad debe ser positiva").default(1),
  corrective_action: z.string().optional(),
});

export type QualityInspectionFormData = z.infer<typeof qualityInspectionSchema>;
export type QualityDefectFormData = z.infer<typeof qualityDefectSchema>;
